import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Checkbox,
} from 'antd';

import styles from './CheckboxItems.module.css';

const CheckboxItems = ({
    list,
    handleChange,
  }) => (
  <Row gutter={15} className={styles.row}>
    {list.length > 0 && list.map((item, index) => (
      <Col
        xs={24}
        lg={24}
        key={index}
        className={styles.col}
      >
        <Checkbox
          defaultChecked={!item.isHidden}
          name={item.name}
          onChange={handleChange}
        >
          {item.name}
        </Checkbox>
      </Col>
    ))}
  </Row>
);

CheckboxItems.propTypes = {
  list: PropTypes.array.isRequired,
};

export default CheckboxItems;
